// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CorrectionsRouteImport } from './routes/corrections'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as EditorialPolicyRouteImport } from './routes/editorial-policy'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CategoryCategoryRouteImport } from './routes/category.$category'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CorrectionsRoute = CorrectionsRouteImport.update({
            id: '/corrections',path: '/corrections',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const EditorialPolicyRoute = EditorialPolicyRouteImport.update({
            id: '/editorial-policy',path: '/editorial-policy',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const CategoryCategoryRoute = CategoryCategoryRouteImport.update({
            id: '/category/$category',path: '/category/$category',getParentRoute: () => rootRouteImport
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BlogRoute: BlogRouteWithChildren,ContactRoute: ContactRoute,CorrectionsRoute: CorrectionsRoute,DisclaimerRoute: DisclaimerRoute,EditorialPolicyRoute: EditorialPolicyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,TermsRoute: TermsRoute,CategoryCategoryRoute: CategoryCategoryRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)